import { DocumentNode, FragmentDefinitionNode } from 'graphql';

/**
 * Retourne le definitionNode d'un documentNode de fragment généré par codegen.
 */
export const getFragmentDefinitionNode = (documentNode: DocumentNode) => {
  return documentNode.definitions[0] as unknown as FragmentDefinitionNode;
};
